import Tag from '@pedidosya/web-fenix/system/Tag';
import BrandPeyaPlusInverted from '@pedidosya/web-fenix/icons/BrandPeyaPlusInverted';
import { Row } from '../styles/styles';

export const TagsRow = ({ discountLabel, renderPlusTag }) => (
  <Row
    paddingBottom="spacing-component-small"
    style={{ display: 'inline-flex' }}
  >
    {renderPlusTag && (
      <Tag
        category="peya-plus"
        icon={<BrandPeyaPlusInverted />}
        borderRadius="left"
        data-testid="peya-plus-tag"
      />
    )}
    {discountLabel && (
      <Tag
        category="deals-and-discounts"
        label={discountLabel}
        borderRadius="right"
      />
    )}
  </Row>
);
